export const setupOptionalEmailValidator = (setFormErrors, tProvider, i18nOpts) => {
  return (email) => {
    if (!email) {
      setFormErrors({ email: '' });
      return true;
    }

    const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!EMAIL_REGEX.test(email)) {
      setFormErrors({ email: tProvider('invalid_email', i18nOpts) });
      return false;
    }

    setFormErrors({ email: '' });
    return true;
  };
};

// Contact type is required.
export const setupContactTypeValidator = (setFormErrors, tProvider, i18nOpts) => {
  return (contactType) => {
    if (!contactType) {
      setFormErrors({ contactType: tProvider('contact_type_required', i18nOpts) });
      return false;
    }

    setFormErrors({ contactType: '' });
    return true;
  };
};

// Contact title (name) is required when contact type is "custom".
export const setupCustomTitleValidator = (setFormErrors, tProvider, i18nOpts) => {
  return (title, contactType) => {
    if (contactType !== 'custom') {
      setFormErrors({ title: '' });
      return true;
    }

    if (!title || !title.trim()) {
      setFormErrors({ title: tProvider('title_required', i18nOpts) });
      return false;
    }

    setFormErrors({ title: '' });
    return true;
  };
};

// At least one of phone or email must be present.
export const setupPhoneOrEmailValidator = (setFormErrors, tProvider, i18nOpts) => {
  return (email, phone) => {
    const hasEmail = email && email.trim();
    const hasPhone = phone && phone.trim();

    if (!hasEmail && !hasPhone) {
      const message = tProvider('phone_or_email_required', i18nOpts);
      setFormErrors({ email: message, phone: message });
      return false;
    }

    setFormErrors({ phone: '' });
    return true;
  };
};
